import { StateMachine } from "../shared/StateMachine";
export class TrainingScenario extends StateMachine {
    constructor(name, author, stages, sequences, objects, events) {
        super();
        this.name = name;
        this.author = author;
        this.stages = stages;
        this.sequences = sequences;
        this.objects = objects;
        this.events = events;
    }
}
